export default __webpack_public_path__ + "static/media/sms_blast.b5867432.svg";